import React, { Component } from 'react';
import { Tooltip } from 'reactstrap';

import isDoubleTouchTap from '../../utils/isDoubleTouchTap';

export default class CopyToClipboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isCopy: false,
      id:
        props.id ||
        'tooltip' +
          Math.random()
            .toString(36)
            .substr(2, 9),
      withTextSelection: props.withTextSelection || false,
      delay: props.delay || 1000
    };
    this.copy = this.copy.bind(this);
  }

  copy(e) {
    if (isDoubleTouchTap(e)) {
      const { isOpen, delay, withTextSelection } = this.state;
      const { text } = this.props;

      if (withTextSelection) {
        const range = document.createRange();
        const sel = window.getSelection();
        range.selectNodeContents(this._target);
        sel.removeAllRanges();
        sel.addRange(range);
      }

      navigator.clipboard.writeText(text);
      this.setState({ isOpen: !isOpen });
      setTimeout(() => {
        this.setState({
          isOpen: false
        });
      }, delay);
    }
  }

  getTarget = target => {
    this._target = target;
  };

  render() {
    const { isOpen, id } = this.state;
    const { text } = this.props;
    return (
      <span>
        <span onTouchEnd={this.copy} ref={this.getTarget} id={id}>
          {text}
        </span>
        <Tooltip placement="top" isOpen={isOpen} target={id}>
          Copied to Clipboard
        </Tooltip>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/copyToClipboard/CopyToClipboard.js